import React from 'react';
import { Box, Typography } from '@mui/material';
import { GiftProduct, GiftProductType } from '../../../../models';
import { AsyncAutocomplete, ImageWithFallback } from '../../../../components';

interface ExistingProductFormProps {
  product: Partial<GiftProduct>;
  onChange: (product: Partial<GiftProduct>) => void;
}

const ExistingProductForm: React.FC<ExistingProductFormProps> = ({ product, onChange }) => {
  const handleProductSelect = (selectedProduct: any) => {
    if (selectedProduct) {
      onChange({
        ...product,
        type: GiftProductType.Existing,
        productId: selectedProduct.id,
        productName: selectedProduct.name,
        productValue: selectedProduct.price,
        productImagePath: selectedProduct.imagePath,
      });
    } else {
      onChange({
        type: GiftProductType.Existing,
        productId: undefined,
        productName: undefined,
      });
    }
  };

  const selectedProduct = product.productId ? { id: product.productId, name: product.productName } : null;

  return (
    <Box>
      <AsyncAutocomplete
        resource="chains/chainId/products"
        label="Selecione o Produto"
        value={selectedProduct}
        onChange={(newValue) => handleProductSelect(newValue)}
        getOptionLabel={(option: any) => option.name || ''}
        filters={{ isDisabled: false }}
        required
        helperText="Selecione um produto existente do catálogo"
        renderOption={(props, option: any) => (
          <li {...props} key={option.id}>
            <Box display="flex" alignItems="center" gap={2} width="100%">
              <ImageWithFallback
                src={option.imagePath}
                alt={option.name}
                width={40}
                height={40}
                borderRadius={4}
              />
              <Box>
                <Typography variant="body1">{option.name}</Typography>
                {option.description && (
                  <Typography variant="body2" color="text.secondary" noWrap sx={{ maxWidth: 300 }}>
                    {option.description}
                  </Typography>
                )}
              </Box>
            </Box>
          </li>
        )}
      />
      {product.productId && (
        <Box mt={3} p={2} border="1px solid" borderColor="divider" borderRadius={2}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Produto Selecionado:
          </Typography>
          <Box display="flex" alignItems="center" gap={2} mt={1}>
            <ImageWithFallback
              src={product.productImagePath}
              alt={product.productName || 'Produto'}
              width={80}
              height={80}
              borderRadius={8}
            />
            <Box>
              <Typography variant="h6">{product.productName}</Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ExistingProductForm;
